import React, { useMemo, useState } from "react";
import YearCalendarBoard from "./YearCalendarBoard";

export default function MaintenanceScheduleEditor({
  entries,
  machines,
  calendarMaps,
  onAdd,
  onToggleDate,
  onRemove,
}) {
  const [year, setYear] = useState(2026);
  const [openMachineId, setOpenMachineId] = useState(null);

  const dateMeta = useMemo(() => {
    const out = {};
    if (!openMachineId) return out;
    const map = calendarMaps?.maintenanceByMachineDate || {};
    Object.entries(map).forEach(([key, enabled]) => {
      const [machineId, date] = key.split("::");
      if (machineId !== openMachineId || !enabled || !date?.startsWith(`${year}-`)) return;
      out[date] = { tone: "danger", label: "Manutenção", badge: "M" };
    });
    return out;
  }, [calendarMaps, openMachineId, year]);

  const visibleEntries = useMemo(
    () => (entries || []).filter((entry) => entry.machineId === openMachineId),
    [entries, openMachineId]
  );

  return (
    <div className="swb-base-section">
      <section className="swb-panel">
        <div className="swb-panel__head">
          <h3>Calendário de manutenção</h3>
          <span className="swb-subtle">Todas as máquinas (cabeçalho por prefixo)</span>
        </div>
        <p className="swb-subtle">
          Clique no cabeçalho da máquina para abrir o calendário e marcar os dias.
        </p>
      </section>

      <div className="swb-accordion-list">
        {(machines || []).map((machine) => {
          const isOpen = openMachineId === machine.id;
          const count = (entries || []).filter((entry) => entry.machineId === machine.id).length;

          return (
            <section key={machine.id} className={`swb-accordion ${isOpen ? "is-open" : ""}`}>
              <button
                type="button"
                className="swb-accordion__head"
                onClick={() => setOpenMachineId((prev) => (prev === machine.id ? null : machine.id))}
              >
                <span>{machine.prefix} ({machine.code})</span>
                <small>{count} registro(s)</small>
              </button>

              {isOpen ? (
                <div className="swb-accordion__body">
                  <div className="swb-inline-actions" style={{ marginBottom: 8 }}>
                    <button type="button" className="swb-btn" onClick={() => onAdd(machine.id)}>
                      Adicionar intervalo manual
                    </button>
                  </div>

                  <YearCalendarBoard
                    year={year}
                    onYearChange={setYear}
                    dateMeta={dateMeta}
                    onDayClick={(date) => onToggleDate?.(machine.id, date)}
                    subtitle="Clique no dia para marcar/desmarcar manutenção."
                  />

                  <section className="swb-panel">
                    <div className="swb-panel__head">
                      <h3>Registros</h3>
                      <span className="swb-subtle">{visibleEntries.length} item(ns)</span>
                    </div>
                    <div className="swb-list">
                      {visibleEntries.length ? (
                        visibleEntries.slice(0, 20).map((entry) => (
                          <div key={entry.id} className="swb-list-item">
                            <div className="swb-list-item__content">
                              <strong>
                                {entry.startDate === entry.endDate
                                  ? entry.startDate
                                  : `${entry.startDate} até ${entry.endDate}`}
                              </strong>
                              <span>{entry.notes || "Sem observação"}</span>
                            </div>
                            <button
                              type="button"
                              className="swb-btn swb-btn--danger"
                              onClick={() => onRemove(entry.id)}
                            >
                              Excluir
                            </button>
                          </div>
                        ))
                      ) : (
                        <div className="swb-empty">Nenhum registro para esta máquina.</div>
                      )}
                    </div>
                  </section>
                </div>
              ) : null}
            </section>
          );
        })}
      </div>
    </div>
  );
}
